import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../Components/Navigation";
import RequireLoginComponent from "../Components/RequireLoginComponent";
import Api from "../Services/Api";
import { Col, Container, Row, Table, Spinner } from "react-bootstrap";
import dayjs from "dayjs";

interface VivantaProgram {
  id: string;
  name: string;
  startsAt: string;
  endsAt: string;
}

const VivantaPrograms = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState<VivantaProgram[]>([]);
  const [loading, setLoading] = useState(true);
  const [isNotAuthenticated, setIsNotAuthenticated] = useState(false);

  useEffect(() => {
    window.rudderanalytics?.page("Programs");
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("staffToken");
    setIsNotAuthenticated(!token);
  }, []);

  useEffect(() => {
    if (isNotAuthenticated) {
      setLoading(false);
      return;
    }
    (async () => {
      setLoading(true);
      const api = new Api();
      const result = await api.getPrograms();
      if (result) setPrograms(result);
      setLoading(false);
    })();
  }, [isNotAuthenticated]);

  return (
    <Fragment>
      <Navigation />
      <Container className="mt-4 mb-5">
        <RequireLoginComponent isNotAuthenticated={isNotAuthenticated} />
        {!isNotAuthenticated && (
          <>
            <Row className="mb-3">
              <Col>
                <h1>Programs</h1>
              </Col>
            </Row>
            {loading ? (
              <div className="d-flex justify-content-center py-5">
                <Spinner animation="border" role="status" />
              </div>
            ) : programs.length === 0 ? (
              <p className="text-muted">No programs found.</p>
            ) : (
              <Table responsive bordered hover className="align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Starts</th>
                    <th>Ends</th>
                  </tr>
                </thead>
                <tbody>
                  {programs.map((program) => (
                    <tr
                      key={program.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/programs/${program.id}/dashboard`)}
                    >
                      <td>{program.name}</td>
                      <td>{dayjs(program.startsAt).format("DD/MM/YYYY")}</td>
                      <td>{dayjs(program.endsAt).format("DD/MM/YYYY")}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </Container>
    </Fragment>
  );
};

export default VivantaPrograms;
